import { onBeforeUnmount } from 'vue'

export function usePreventPullToRefresh({ onRefresh }) {
    let touchstartHandler = null
    let touchmoveHandler = null
    let pullListenersAttached = false

    const attach = () => {
        if (pullListenersAttached) return

        let lastTouchY = 0
        let maybePreventPullToRefresh = false

        touchstartHandler = (e) => {
            if (e.touches.length !== 1) return
            lastTouchY = e.touches[0].clientY
            maybePreventPullToRefresh = window.pageYOffset === 0
        }

        touchmoveHandler = async (e) => {
            const touchY = e.touches[0].clientY
            const touchYDelta = touchY - lastTouchY
            lastTouchY = touchY

            if (!maybePreventPullToRefresh) return
            maybePreventPullToRefresh = false

            if (touchYDelta > 0) {
                e.preventDefault()
                await onRefresh?.()
            }
        }

        document.addEventListener('touchstart', touchstartHandler, false)
        document.addEventListener('touchmove', touchmoveHandler, false)
        pullListenersAttached = true
    }

    const detach = () => {
        if (!pullListenersAttached) return

        document.removeEventListener('touchstart', touchstartHandler, false)
        document.removeEventListener('touchmove', touchmoveHandler, false)

        touchstartHandler = null
        touchmoveHandler = null
        pullListenersAttached = false
    }

    onBeforeUnmount(detach)

    return { attach, detach }
}
